import { render, staticRenderFns } from "./PersonalSoftIVA.vue?vue&type=template&id=fe46841c&scoped=true&"
import script from "./PersonalSoftIVA.vue?vue&type=script&lang=js&"
export * from "./PersonalSoftIVA.vue?vue&type=script&lang=js&"
import style0 from "./PersonalSoftIVA.vue?vue&type=style&index=0&id=fe46841c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe46841c",
  null
  
)

export default component.exports